<div class="row float-right fp-container">

  <div class="col-md-12 ">
    <div class="row no-pad mar-btm-30 ">
      <!-- <h2 class="col-md-12 mar-top-30 ">Forgot UserName</h2> -->
    </div>
    <form #f="ngForm" novalidate (ngSubmit)="f.form.valid && save(f.value, f.valid)" novalidate>
      <div class="form-group">
        <!-- <H4>Kindly contact the IT Administrator.</H4> -->
        <label class="col-sm-6 col-form-label pos">Email Address
          <span class="required">*</span>
        </label>

        <input type="email" class="form-control" name="username" [ngModel]="user.username" required #username="ngModel">
        <small [hidden]="username.valid || (username.pristine && !f.submitted)" class="text-danger">
          Email Address is required.
        </small>

      </div>
      <div class="form-group">
        <button type="submit" value="Submit" class="btn btn-dark">SEND</button>
      </div>
    </form>
    <a href="#"> <i class="fa fa-lock"></i> {{'Back to Login' | translate }}</a>
  </div>
</div>